<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import SidebarUnreadBadge from './SidebarUnreadBadge.vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  // eslint-disable-next-line vue/no-unused-properties
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
  badgeCount: {
    type: [Number, String],
    default: 0,
  },
});

const reauthorizationRequired = computed(() => {
  return props.inbox.reauthorization_required;
});

const online = computed(() => {
  if (props.inbox.online !== undefined && props.inbox.online !== null) {
    return props.inbox.online;
  }
  if (props.inbox.reauthorization_required) return false;
  if (
    props.inbox.channel_type === 'Channel::Whatsapp' &&
    props.inbox.provider === 'wuzapi'
  ) {
    // wuzapi: online somente após o pareamento (telefone real sincronizado)
    return !/^wuzapi\d+$/.test(props.inbox.phone_number || '');
  }
  if (props.inbox.channel_type === 'Channel::Whatsapp') {
    return !!(props.inbox.phone_number && !props.inbox.reauthorization_required);
  }
  if (props.inbox.channel_type === 'Channel::Email') {
    return !!(props.inbox.imap_address && props.inbox.smtp_address);
  }
  return true;
});
</script>

<template>
  <span class="relative size-4 grid place-content-center rounded-full">
    <ChannelIcon :inbox="inbox" class="size-4" />
    <span
      class="absolute -bottom-0.5 ltr:-right-0.5 rtl:-left-0.5 size-2 rounded-full border border-n-background"
      :class="online ? 'bg-n-teal-9' : 'bg-n-ruby-9'"
      :title="online ? 'Online' : 'Offline'"
    />
  </span>
  <div class="flex-1 truncate min-w-0">{{ label }}</div>
  <SidebarUnreadBadge :count="badgeCount" />
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>
